module.exports = __webpack_public_path__ + "img/sampleb.9c4bf15c.png";